"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.invoiceWithOldDepartments = exports.allInvoices = void 0;
var utils_1 = require("../../utils/utils");
exports.allInvoices = {
    summary: {
        departments: {
            "10030010328": "10030010328"
        },
        fee_schedules: {
            "5000356": "5000356"
        },
        existing_departments: [
            {
                code: "10030010328",
                name: "BWH CYTOLOGY"
            }
        ],
        all_departments: [
            {
                code: "10040010016",
                name: "BWF CYTOPATHOLOGY"
            },
            {
                code: "10040010018",
                name: "BWF PATHOLOGY LAB"
            },
            {
                code: "10030010520",
                name: "BWH ANATOMIC PATHOLOGY"
            },
            {
                code: "10030010292",
                name: "BWH CHEMISTRY"
            },
            {
                code: "10030010328",
                name: "BWH CYTOLOGY"
            },
            {
                code: "10040010014",
                name: "BWF LAB CHEMISTRY"
            },
            {
                code: "10030011183",
                name: "BWH CLINICAL ONCOPANEL LAB"
            },
            {
                code: "10030010519",
                name: "BWH CYTOGENETICS"
            },
            {
                code: "10030010293",
                name: "BWH HEMATOLOGY"
            },
            {
                code: "10030010284",
                name: "BWH MOLECULAR DIAG"
            }
        ]
    },
    required_fields: [],
    invoices: [
        {
            type: null,
            guid: "90457ccb-bda6-4a22-b815-377b1efb382a",
            date_of_service: "2023-04-20",
            datetime_of_service: "2023-04-20 00:00:00 EDT",
            department_code: "10030010328",
            department: {
                name: "test",
                code: "10030010328"
            },
            patient_type: "",
            billing_location: null,
            billing_area: null,
            fee_schedule: "5000356",
            division: null,
            facility: null,
            filler_number: {
                number: "E80b6ba2cb25243bd98b856fbd4e20037",
                issuer: "EPIC",
                type: "SPECIMEN_NUMBER"
            },
            billing_provider_name: "Cadigan, Philip",
            billing_provider_number: {
                number: "23423423",
                issuer: "EPIC",
                type: "IDNO"
            },
            ordering_provider_name: null,
            ordering_provider_number: {
                number: null,
                issuer: "EPIC",
                type: "IDNO"
            },
            referring_provider_name: null,
            referring_provider_number: {
                number: null,
                issuer: null,
                type: null
            },
            performing_provider_name: null,
            performing_provider_number: {
                number: null,
                issuer: "EPIC",
                type: "IDNO"
            },
            transactions: [],
            deleted: true,
            health_plan_id: null,
            billing_provider_type: null,
            ordering_provider_type: null,
            referring_provider_type: null,
            performing_provider_type: null
        },
        {
            type: null,
            guid: "a0ca258a-f752-4cae-b9f2-2c3159d1f2bd",
            date_of_service: "2023-04-20",
            datetime_of_service: "2023-04-20 00:00:00 EDT",
            department_code: "10030010328",
            department: {
                name: "test",
                code: "10030010328"
            },
            patient_type: "",
            billing_location: null,
            billing_area: null,
            fee_schedule: "5000356",
            division: null,
            facility: null,
            filler_number: {
                number: "E80b6ba2cb25243bd98b856fbd4e20037",
                issuer: "EPIC",
                type: "SPECIMEN_NUMBER"
            },
            billing_provider_name: "Cadigan, Philip",
            billing_provider_number: {
                number: "23423423",
                issuer: "EPIC",
                type: "IDNO"
            },
            ordering_provider_name: null,
            ordering_provider_number: {
                number: null,
                issuer: "EPIC",
                type: "IDNO"
            },
            referring_provider_name: null,
            referring_provider_number: {
                number: null,
                issuer: null,
                type: null
            },
            performing_provider_name: null,
            performing_provider_number: {
                number: null,
                issuer: "EPIC",
                type: "IDNO"
            },
            transactions: [],
            deleted: true,
            health_plan_id: null,
            billing_provider_type: null,
            ordering_provider_type: null,
            referring_provider_type: null,
            performing_provider_type: null
        },
        {
            type: null,
            guid: "5b460f21-128e-4bf0-93d0-294945ba72d5",
            date_of_service: "2023-04-20",
            datetime_of_service: "2023-04-20 00:00:00 EDT",
            department_code: "10030010328",
            department: {
                name: "test",
                code: "10030010328"
            },
            patient_type: "",
            billing_location: null,
            billing_area: null,
            fee_schedule: "5000356",
            division: null,
            facility: null,
            filler_number: {
                number: "E80b6ba2cb25243bd98b856fbd4e20037",
                issuer: "EPIC",
                type: "SPECIMEN_NUMBER"
            },
            billing_provider_name: "Cadigan, Philip",
            billing_provider_number: {
                number: "23423423",
                issuer: "EPIC",
                type: "IDNO"
            },
            ordering_provider_name: null,
            ordering_provider_number: {
                number: null,
                issuer: "EPIC",
                type: "IDNO"
            },
            referring_provider_name: null,
            referring_provider_number: {
                number: null,
                issuer: null,
                type: null
            },
            performing_provider_name: null,
            performing_provider_number: {
                number: null,
                issuer: "EPIC",
                type: "IDNO"
            },
            transactions: [],
            deleted: false,
            health_plan_id: null,
            billing_provider_type: null,
            ordering_provider_type: null,
            referring_provider_type: null,
            performing_provider_type: null
        },
        {
            type: null,
            guid: "ca16f2dc-02d3-4b57-b066-606aadcd566d",
            date_of_service: "2023-04-20",
            datetime_of_service: "2023-04-20 00:00:00 EDT",
            department_code: "10030010328",
            department: {
                name: "test",
                code: "10030010328"
            },
            patient_type: "",
            billing_location: null,
            billing_area: null,
            fee_schedule: "5000356",
            division: null,
            facility: null,
            filler_number: {
                number: "E80b6ba2cb25243bd98b856fbd4e20037",
                issuer: "EPIC",
                type: "SPECIMEN_NUMBER"
            },
            billing_provider_name: "Doyle, Jack",
            billing_provider_number: {
                number: "23423423",
                issuer: "EPIC",
                type: "IDNO"
            },
            ordering_provider_name: null,
            ordering_provider_number: {
                number: null,
                issuer: "EPIC",
                type: "IDNO"
            },
            referring_provider_name: null,
            referring_provider_number: {
                number: null,
                issuer: null,
                type: null
            },
            performing_provider_name: null,
            performing_provider_number: {
                number: null,
                issuer: "EPIC",
                type: "IDNO"
            },
            transactions: [],
            deleted: true,
            health_plan_id: null,
            billing_provider_type: null,
            ordering_provider_type: null,
            referring_provider_type: null,
            performing_provider_type: null
        },
        {
            type: "assembled",
            guid: "24bf8e5c-ad12-4c80-adb0-05e5f501ee6c",
            date_of_service: "2023-04-19",
            datetime_of_service: "2023-04-20 00:00:00 EDT",
            department_code: "10030010328",
            department: {
                name: "test",
                code: "10030010328"
            },
            patient_type: "",
            billing_location: null,
            billing_area: null,
            fee_schedule: "5000356",
            division: null,
            facility: null,
            filler_number: {
                number: "E80b6ba2cb25243bd98b856fbd4e20037",
                issuer: "EPIC",
                type: "SPECIMEN_NUMBER"
            },
            billing_provider_name: "Cardigan, Philip",
            billing_provider_number: {
                number: "23423423",
                issuer: "EPIC",
                type: "IDNO"
            },
            ordering_provider_name: null,
            ordering_provider_number: {
                number: null,
                issuer: "EPIC",
                type: "IDNO"
            },
            referring_provider_name: null,
            referring_provider_number: {
                number: null,
                issuer: null,
                type: null
            },
            performing_provider_name: null,
            performing_provider_number: {
                number: null,
                issuer: "EPIC",
                type: "IDNO"
            },
            transactions: [],
            deleted: true,
            health_plan_id: null,
            billing_provider_type: null,
            ordering_provider_type: null,
            referring_provider_type: null,
            performing_provider_type: null
        }
    ]
};
exports.invoiceWithOldDepartments = {
    required_fields: [],
    summary: {
        departments: {
            "1050010130": "1050010130",
            "1060010006": "1060010006",
            "10030010328": "10030010328"
        },
        existing_departments: [
            {
                code: "1050010130",
                name: "HFWH - VICU"
            },
            {
                code: "10030010328",
                name: "BWH CYTOLOGY"
            },
            {
                code: "1060010006",
                name: null
            }
        ],
        all_departments: [
            {
                code: "1120010092",
                name: "AH- HFAH PALLIATIVE MEDICINE CONSULTS"
            },
            {
                code: "1040030051",
                name: "WBH-WB CLINIC PERINATAL OUTREACH, SUPPORT, AND TREATMENT"
            },
            {
                code: "1010010310",
                name: "HFH - VICU"
            },
            {
                code: "1040010107",
                name: "HFWB - VICU"
            },
            {
                code: "1050010130",
                name: "HFWH - VICU"
            },
            {
                code: "1060010098",
                name: "HFM - VICU"
            },
            {
                code: "1120190008",
                name: "AH-JACKSON ACUTE CARE CLINIC"
            }
        ],
        fee_schedules: {}
    },
    invoices: (0, utils_1.cloneDeep)(exports.allInvoices.invoices)
};
//# sourceMappingURL=all-invoices.js.map